import React, { useRef } from 'react'

// Deps
import { connect } from 'react-redux'

// Partials
import Btn from 'views/shared/partials/btn'
import { MapMarker, MapElement } from 'views/shared/partials/mapelement'

const mapStateToProps = (state) => {
	const group = state.user.data ? state.user.data.default_group : false;
	return {
		userStore: group ? {
			...group,
			latitude: group.latitude ? parseFloat(group.latitude) : false,
			longitude: group.longitude ? parseFloat(group.longitude) : false
		} : false,
	};
};

const OrderStoresMapModal = ({mode, className, close, closeBtn, stockInfo, userStore, ...props}) => {
	const stores = useRef(stockInfo.map((info) => {
		return {
			...info,
			group: {
				...info.group,
			}
		};
	}));
	
	return (
		<div className={className}>
			<div className="modal-header">
				<h1 className="header-title">
					Mağaza Stokları
				</h1>
				{closeBtn}
			</div>
			<MapElement
				zoom={userStore ? 11 : 8}
				lat={userStore ? userStore.latitude : undefined}
				lng={userStore ? userStore.longitude : undefined}
				className="modal-content map-elem">
				{stores.current.filter(store => store.group.latitude && store.group.longitude).map((store, nth) => (
					<MapMarker
						className={(store.stock !== 0 ? 'has-stock' : 'no-stock') + (userStore && store.group.id === userStore.id ? ' user-store' : '')}
						infoBar={
							<>
								<strong className="infobar-title">{store.group.name}</strong>
								<p><strong>Stok adedi:</strong> {store.stock}</p>
							</>
						}
						key={nth}
						lat={store.group.latitude}
						lng={store.group.longitude} />
				))}
			</MapElement>
			<div className="modal-controls">
				<Btn
					big gray outline
					onClick={close}>
					Tamam
				</Btn>
			</div>
		</div>
	)
}

const ConnectedModal = connect(mapStateToProps)(OrderStoresMapModal);

ConnectedModal.defaultProps = {
	className: '',
	containerClass: 'modal-order-stores-map mobile-full',
	name: 'order-stores-map',
}

export default ConnectedModal
